import { useQuery } from '@tanstack/react-query';
import PackageProviderService from '../services/settings/ppoints/PackageProviderService';

export const useCountries = () => {
    return useQuery({
        queryKey: ['countries'],
        queryFn: () => PackageProviderService.getCountries(),
        staleTime: 5 * 60000,
        cacheTime: 10 * 60000,
    });
};
